var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "discuss_wrap" },
    [
      !_vm.isEdit
        ? _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                "label-position": "top",
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "主题", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.ruleForm.discussSearchValue,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "discussSearchValue", $$v)
                      },
                      expression: "ruleForm.discussSearchValue"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "内容", prop: "desc" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.ruleForm.desc,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "desc", $$v)
                      },
                      expression: "ruleForm.desc"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isEdit
        ? _c(
            "div",
            { staticClass: "btn_wrap" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.addDiscuss }
                },
                [_vm._v("发表")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isEdit
        ? _c("div", { staticClass: "show_list" }, [
            _c("div", { staticClass: "title" }, [
              _c(
                "div",
                [
                  _vm._v("中联教师"),
                  _c(
                    "el-tag",
                    { staticClass: "tag", attrs: { size: "mini" } },
                    [_vm._v("教师")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "time" }, [_vm._v("昨天16:16")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "quest" }, [_vm._v("这道题怎么做")]),
            _vm._v(" "),
            _c("div", { staticClass: "quest_type" }, [_vm._v("全部章节")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEdit
        ? _c("div", { staticClass: "show_list" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "quest" }, [_vm._v("这道题难")]),
            _vm._v(" "),
            _vm._m(1)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEdit
        ? _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              staticStyle: { "margin-top": "20px" },
              attrs: {
                "label-position": "top",
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "desc" } },
                [
                  _c("el-input", {
                    staticStyle: { height: "100px" },
                    attrs: {
                      placeholder: "欢迎留言交流",
                      maxlength: "300",
                      "show-word-limit": "",
                      type: "textarea"
                    },
                    model: {
                      value: _vm.ruleForm.desc,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "desc", $$v)
                      },
                      expression: "ruleForm.desc"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEdit
        ? _c(
            "div",
            { staticClass: "btn_wrap" },
            [
              _c("el-button", { attrs: { type: "primary", size: "small" } }, [
                _vm._v("发表留言")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEdit
        ? _c("div", { staticClass: "list" }, [
            _c("div", [_vm._v("全部回复  3")]),
            _vm._v(" "),
            _c("div", { staticClass: "answer_list" }, [
              _c("div", [_vm._v("啥也不会")]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  [
                    _vm._v("中联教师"),
                    _c(
                      "el-tag",
                      { staticClass: "tag", attrs: { size: "mini" } },
                      [_vm._v("教师")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "time" }, [_vm._v("昨天16:16")])
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", [_vm._v("这道题怎么做")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "quest_type" }, [
      _vm._v("中联教育 "),
      _c("div", { staticClass: "date" }, [_vm._v("昨天16:16")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f5da5ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f5da5ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponent/discuss/discuss.vue
// module id = null
// module chunks = 